module.exports = __webpack_public_path__ + "static/media/bell.bfa6ccf3.svg";